import { render, staticRenderFns } from "./MetricCategoryList.vue?vue&type=template&id=56942efc"
import script from "./MetricCategoryList.vue?vue&type=script&lang=js"
export * from "./MetricCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports